import { FormLabel, FormLabelProps } from '@chakra-ui/react';

const Label = ({ variant = 'outline', children, ...props }: FormLabelProps) => (
  <FormLabel variant={variant} {...props}>
    {children}
  </FormLabel>
);

export default Label;
